<template>
  <div id="offcanvas" class="uk-offcanvas" uk-offcanvas>
    <div class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close" type="button" uk-close></button>
      <h3>{{ $t('title') }}</h3>
      <ul class="uk-nav uk-nav-default">
        <li v-for="(item, key) in menu" :key="key">
          <router-link :to="{ name: `${item}` }">{{ $t(`route.${key}`) }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Terms' }">{{ $t('route.terms') }}</router-link>
        </li>
        <li class="uk-parent uk-nav-header">
          {{ $t('route.language') }}
          <ul class="uk-nav-sub">
            <li v-for="(language, code) in languages" :key="code" :class="{'uk-active': code == lang}">
              <a :href="'/' + code" @click.prevent="changeLanguage(code)">
                {{ code }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([
      'menu',
      'languages'
    ]),

    lang () {
      return this.$root.$i18n.locale
    }
  },

  methods: {
    changeLanguage (lang) {
      this.$emit('changeLanguage', lang)

      uikit.offcanvas('#offcanvas').hide()
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../assets/flags/css/flag-icon-app.min.css';

  button.uk-close {
    right: 10px;
    top: 10px;
  }

  h3 {
    margin-top: 0;
    padding-right: 14px;
  }

  .uk-offcanvas-bar .uk-nav-default {
    & .uk-nav-sub li.uk-active a {
      color: #FFF;
    }

    & > li > a.uk-active {
      color: #FFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_layout/Offcanvas.vue